import type { SerializerOptions } from '@ember-data/legacy-compat';
import type { Snapshot } from '@ember-data/legacy-compat/-private';
import type { ModelSchema } from '@ember-data/store/types';

import type { RecordData } from 'webapp-types';

import ApplicationSerializer from 'webapp/serializers/application';

export default class HorizonMetricSerializer extends ApplicationSerializer {
	override getReadOnlyFields(
		_json: Record<string, unknown>,
	): RecordData.HorizonMetric.ReadOnlyKey[] {
		return [
			'spaceAccessId',
			'created',
			'createdBy',
			'modified',
			'modifiedBy',
			'statusObject',
			'verificationInfo',
		];
	}

	override serialize(
		snapshot: Snapshot,
		options: SerializerOptions,
	): RecordData.HorizonMetric.Serialized {
		// read-only fields are already removed by ApplicationSerializer
		return super.serialize(snapshot, options) as RecordData.HorizonMetric.Serialized;
	}

	// sent without a root key
	serializeIntoHash(
		hash: Record<string, unknown>,
		typeClass: ModelSchema,
		snapshot: Snapshot,
		options: SerializerOptions,
	) {
		Object.assign(hash, this.serialize(snapshot, options));
	}
}
